import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useFunnelStore } from '../../store/useFunnelStore';
import './SubscriptionError.css';
import { useTranslation } from 'react-i18next';

const SubscriptionError: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { getCheckoutData } = useFunnelStore();
  const { t } = useTranslation();

  // Get data from navigation state
  const { priceId, productId } = location.state || {};

  // Get stored checkout data to retrieve pricing information
  const checkoutData = getCheckoutData();

  const handleRetry = () => {
    // Navigate back to checkout page with stored data
    const navigationState = {
      priceId: priceId || checkoutData.selectedPrice,
      productId: productId
    };

    if (navigationState.priceId && navigationState.productId) {
      navigate('/checkout', { state: navigationState });
    } else {
      // Fallback to plans page if we don't have the required data
      navigate('/plans');
    }
  };

  return (
    <div className="subscription-error-bg">
      <div className="subscription-error-container">
        <div className="subscription-error-card">
          {/* Top Icon */}
          <div className="subscription-error-icon">
            <div className="error-circle">
              <span className="error-x">✕</span>
            </div>
          </div>

          {/* Main Title */}
          <h1 className="subscription-error-title">{t('subscriptionError.title')}</h1>

          {/* Subtitle */}
          <p className="subscription-error-subtitle">
            {t('subscriptionError.subtitle')}
          </p>

          {/* What you can do section */}
          <div className="subscription-error-actions-section">
            <h2 className="actions-title">{t('subscriptionError.actionsTitle')}</h2>
            <div className="actions-list">
              <div className="action-item">
                <span>• {t('subscriptionError.actions.checkCard')}</span>
              </div>
              <div className="action-item">
                <span>• {t('subscriptionError.actions.tryMethod')}</span>
              </div>
              <div className="action-item">
                <span>• {t('subscriptionError.actions.contactBank')}</span>
              </div>
              <div className="action-item">
                <span>• {t('subscriptionError.actions.contactSupport')}</span>
              </div>
            </div>
          </div>

          {/* Try Again Button */}
          <button className="try-again-btn" onClick={handleRetry}>
            {t('subscriptionError.tryAgainButton')}
          </button>

          {/* Support Section */}
          <div className="subscription-error-support-section">
            <p className="support-text">{t('subscriptionError.supportText')}</p>
            <a href={`mailto:${t('subscriptionError.supportEmail')}`} className="support-email">
              {t('subscriptionError.supportEmail')}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionError;
